import { createReducer, on } from '@ngrx/store';
import { updateFundChartSecurityOrdering } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securities/securities.actions';
import { setFundChartSortColumn } from './sort-column.actions';
export const sortColumn = createReducer('', on(setFundChartSortColumn, (state, action) => {
    return action.sortColumn;
}), on(updateFundChartSecurityOrdering, () => {
    return '';
}));
